import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from '@/api/base/base-api';

export const baseRestV4Api = createApi({
  reducerPath: 'restV4Api',
  baseQuery: baseQueryWithReAuth,
  endpoints: () => ({}),
});
